(() => {
  const modal = document.getElementById("modal");
  const closeModal = document.getElementById("closeModal");
  const modalOpeners = document.querySelectorAll(".js-open-modal");
  const modalTitle = modal.querySelector(".js-modal-title");
  const modalContent = modal.querySelector(".js-modal-content");
  const modalImg = modal.querySelector(".js-modal-image");
  const modalBadges = modal.querySelector(".js-modal-badges");
  const primaryBadge = modal.querySelector(".js-modal-badge-primary");
  const secondaryBadge = modal.querySelector(".js-modal-badge-secondary");
  const modalDate = modal.querySelector(".js-modal-date");
  const imgWrapper = modal.querySelector(".js-modal-image-wrapper");
  const modalLink = modal.querySelector(".js-modal-link");

  const generateBadge = (badge) =>
    `<span class="modal__badge modal__badge--neutral">${badge}</span>`;

  closeModal.addEventListener("click", () => {
    modal.style.display = "none";
  });

  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  });

  modalOpeners.forEach((opener) => {
    opener.addEventListener("click", () => {
      const newTitle = opener.querySelector(".js-modal-title").innerHTML;
      const newContent = opener.querySelector(".js-modal-content").innerHTML;
      const newImgUrl = opener.dataset.imgUrl;
      const isPrimary = opener.dataset.productPrimary;
      const {productUrl} = opener.dataset;
      
      if (newImgUrl) {
        imgWrapper.style.display = "block";
        modalImg.src = newImgUrl;
        modalLink.href = productUrl;
        closeModal.style.display = "flex";
      } else {
        imgWrapper.style.display = "none";
        closeModal.style.display = "none";
      }
      if (isPrimary === "true") {
        primaryBadge.style.display = "block";
        secondaryBadge.style.display = "none";
      } else {
        primaryBadge.style.display = "none";
        secondaryBadge.style.display = "block";
      }
      const oldBadges = modalBadges.querySelectorAll(".modal__badge--neutral");
      oldBadges.forEach((badge) => badge.remove());
      const newBadgesArary = opener.dataset?.details?.split(", ");
      newBadgesArary?.forEach((badge) => {
        modalBadges.innerHTML += generateBadge(badge);
      });
      modalTitle.innerHTML = newTitle;
      modalContent.innerHTML = newContent;
      modalDate.innerHTML = opener.dataset.date || "";
      modal.style.display = "flex";
    });
  });
})();
